import { useTourFiltersStore } from '@/entities/filter/store/tour';
import { useLoaderStore } from '@/shared/store/useLoaderStore.ts';
import { SMALL_OUTPUT_THRESHOLD } from '../../lib/consts';
import { filterScroll } from '@/shared/lib/use-scroll';
import { inject, type useShadowRoot } from 'vue';

export const useTourSmallOutput = () => {
  const filtersStore = useTourFiltersStore();
  const loaderStore = useLoaderStore();

  const rootNode = inject<ReturnType<typeof useShadowRoot>>('shadowRoot', null);

  const showSmallOutput = computed(
    () =>
      filtersStore.isFiltersApplied &&
      filtersStore.isFirstExperiencesLoaded &&
      !filtersStore.isSearchLoading &&
      !loaderStore.isFiltersLoading &&
      (filtersStore.searchTotalCount || 0) <= SMALL_OUTPUT_THRESHOLD,
  );

  watch(
    () => showSmallOutput.value,
    (value) => {
      if (value) {
        filterScroll(rootNode);
      }
    },
  );

  return {
    showSmallOutput,
  };
};
